import React from "react";
import { motion } from "framer-motion";
import { useLang } from "../context/LanguageContext";

const projects = [
  { img: "/images/projects/groningen-tesla.png", title: "Groningen Centrum", spec: "18 panelen · Tesla Powerwall 3", saving: "€ 2.840 / jaar" },
  { img: "/images/projects/haren-huawei.png", title: "Haren (Groningen)", spec: "12 panelen · Huawei Luna2000 10kWh", saving: "€ 1.920 / jaar" },
  { img: "/images/projects/zuidhorn-byd.png", title: "Zuidhorn", spec: "24 panelen · BYD 15kWh thuisbatterij", saving: "€ 3.260 / jaar" },
];

const ProjectShowcase = () => {
  const { t } = useLang();
  return (
    <section className="section-pad bg-white" data-testid="project-showcase">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div className="max-w-xl">
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-brand mb-3">{t.projects.eyebrow}</p>
            <h2 className="font-heading text-4xl md:text-5xl font-black tracking-tighter text-navy-900 text-balance">{t.projects.title}</h2>
          </div>
          <p className="text-slate-600 text-lg max-w-md">{t.projects.subtitle}</p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {projects.map((p, i) => (
            <motion.div
              key={p.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="group relative rounded-3xl overflow-hidden aspect-[4/5] cursor-pointer"
              data-testid={`project-card-${i}`}
            >
              <img src={p.img} alt={p.title} className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
              <div className="absolute inset-0 bg-gradient-to-t from-navy-900 via-navy-900/30 to-transparent" />
              <div className="absolute inset-0 p-7 flex flex-col justify-end text-white">
                <div className="inline-flex w-fit px-3 py-1 rounded-full bg-brand/90 backdrop-blur text-xs font-bold tracking-wide mb-3">{p.saving}</div>
                <h3 className="font-heading text-2xl font-black mb-1">{p.title}</h3>
                <p className="text-sm text-slate-200">{p.spec}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProjectShowcase;
